export default __webpack_public_path__ + "static/media/Group1497-TataNeu@2x.c166b43d.png";